/**
 * @file Defines the form inputs for editing a user's mobile number.
 */

import { TYPE_NONE } from "@components/Form";

type UpdateInput = {
  name: "mobile" | "givenName" | "familyName";
  type?: typeof TYPE_NONE;
};

/**
 * Builds the form inputs for the mobile number edit form.
 */
const getUpdateInputs = (): UpdateInput[] => {
  return [
    { name: "mobile" },
    { name: "givenName", type: TYPE_NONE },
    { name: "familyName", type: TYPE_NONE },
  ];
};

export default getUpdateInputs;
